import type { PropsWithChildren } from "react";

import { Content } from "~/components/app/content";

/**
 * Lightweight chrome for the read-only board viewer.
 *
 * Renders just the rounded inset content area — `TopBar`,
 * `SidebarProvider`, `DocumentTitle`, etc. live at the root layout so
 * they appear under both app and guest sessions. We deliberately do
 * **not** mount `<App>` (which brings the sidebar, chat panel, and the
 * supervisor agent providers) so anonymous public link viewers don't
 * pull in editor-only code or attempt to subscribe to Ably.
 *
 * `Content` is set to `standalone` so the rounded card chrome appears
 * even without a `<Sidebar variant="inset">` peer.
 */
export const GuestBoardLayout = ({ children }: PropsWithChildren) => {
  return <Content standalone>{children}</Content>;
};
